import { Component, Input, OnInit } from '@angular/core';
import { HomeItem } from 'src/app/models/home-item';


@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {
  @Input() iconItem :HomeItem = {
    name: '',
    img: '',
    link: ''
  };
  title = "Dashboard"

  ngOnInit(): void {
    // do something
  }

}
